import React from 'react'
import { Icon, IconProps } from '~/design_system'

export const AssistantSparkle = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <g className="wd-icon-container">
        <path
          d="m7.927 18.892.23.126a8 8 0 1 0-3.192-3.206l.132.244-.558 3.282z"
          className="wd-icon-background"
          fill="currentColor"
          opacity="0.1"
        />
        <path
          d="M12 2.5a.48.48 0 0 0-.5-.488C6.21 2.272 2 6.645 2 12a9.96 9.96 0 0 0 1.071 4.507l-.627 3.685a1.046 1.046 0 0 0 1.169 1.214l3.827-.504A9.96 9.96 0 0 0 12 22c5.355 0 9.727-4.21 9.988-9.5a.48.48 0 0 0-.488-.5h-1a.525.525 0 0 0-.515.5 8 8 0 0 1-11.828 6.518l-.23-.126-3.388.446.558-3.282-.132-.243A8 8 0 0 1 11.5 4.016c.275-.018.5-.24.5-.516z"
          className="wd-icon-fill"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          d="M17.5 2c.181 0 .407.113.456.371.185.988.582 1.814 1.184 2.438.6.622 1.42 1.059 2.479 1.244.509.089.507.805 0 .894-1.058.185-1.878.622-2.479 1.244-.602.624-1 1.45-1.184 2.438A.46.46 0 0 1 17.5 11a.456.456 0 0 1-.456-.371c-.185-.988-.582-1.814-1.184-2.438-.6-.622-1.42-1.059-2.479-1.244-.509-.09-.507-.805 0-.894 1.058-.185 1.878-.622 2.479-1.244.602-.624 1-1.45 1.184-2.438A.46.46 0 0 1 17.5 2Z"
          className="wd-icon-accent"
          clipRule="evenodd"
          fill="currentColor"
          opacity="0.8"
        />
      </g>
    </Icon>
  )
}
